import React from 'react';
import { getRouteApi } from '@tanstack/react-router';

import AccountProfileEdit from './ProfileEdit';

const AccountProfile: React.FC = () => {
  const routeApi = getRouteApi('/account');
  const { profile } = routeApi.useLoaderData();

  return (
    <div className="container account-container account-profile-container">
      <div className="account-header page-header">
        <h2 className="page-title">My <em>profile</em></h2>
      </div>
      <AccountProfileEdit profile={profile} />
    </div>
  );
}

export default AccountProfile;
